export default class ExtraActionsListingDTO {
  icon: string = '';
  tooltip: string = '';
  severity: 'success' | 'info' | 'warning' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast' | null | undefined = 'primary';
  label: string = '';
  color: string = '';
  action!: (prop: any) => void;
  disabled: boolean | ((prop: any) => boolean) = false;
  visible: boolean | ((prop: any) => boolean) = true;

  constructor(init?: Partial<ExtraActionsListingDTO>) {
    Object.assign(this, init);
  }



}
